class HeaderWrapper extends HTMLElement {
  constructor() {
    super();

    const menu = this.querySelector("[data-menu]");
    const menuShowButton = this.querySelector("[data-menu-show]");
    const menuCloseButton = this.querySelector("[data-menu-close]");
    const menuRoot = this.querySelector("[data-menu-root]");
    const menuPanelShowButtons = this.querySelectorAll(
      "[data-menu-panel-show]",
    );
    const submenuPanelShowButtons = this.querySelectorAll(
      "[data-submenu-panel-show]",
    );
    const menuBackdrop = this.querySelector("[data-menu-backdrop]");
    const panelShowButtons = this.querySelectorAll("[data-panel-show]");
    const searchShowButtons = this.querySelectorAll("[data-search-show]");
    const backdrop = this.querySelector("[data-backdrop]");
    const mediaQueryList = window.matchMedia("(min-width: 64em)");
    const searchPanel = this.querySelector("[data-search]");

    const showMenu = () => {
      if (menu.showModal) {
        menu.showModal();
      } else {
        menu.setAttribute("open", "");
      }

      document.body.classList.add("overflow-hidden");
      menuBackdrop.setAttribute("data-active", "");
    };

    menuShowButton.addEventListener("click", showMenu);

    const closeMenu = () => {
      if (menu.close) {
        menu.close();
      } else {
        menu.removeAttribute("open");
      }

      document.body.classList.remove("overflow-hidden");
      menuBackdrop.removeAttribute("data-active");
    };

    menuCloseButton.addEventListener("click", closeMenu);

    menuPanelShowButtons.forEach((showButton) => {
      const id = showButton.getAttribute("aria-controls");
      const menuPanel = document.getElementById(id);
      const closeButton = menuPanel.querySelector("[data-menu-panel-close]");

      showButton.addEventListener("click", () => {
        if (menuPanel.show) {
          menuPanel.show();
        } else {
          menuPanel.setAttribute("open", "");
        }

        menuRoot.setAttribute("hidden", "");
        menuPanel.focus();
      });

      closeButton.addEventListener("click", () => {
        if (menuPanel.close) {
          menuPanel.close();
        } else {
          menuPanel.removeAttribute("open");
        }

        menuRoot.removeAttribute("hidden");
        showButton.focus();
      });

      submenuPanelShowButtons.forEach((showButton) => {
        const id = showButton.getAttribute("aria-controls");
        const submenuPanel = document.getElementById(id);
        const submenuCloseButton = submenuPanel.querySelector(
          "[data-submenu-panel-close]",
        );

        showButton.addEventListener("click", () => {
          menuPanel.setAttribute("hidden", "");
          if (submenuPanel.show) {
            submenuPanel.show();
          } else {
            submenuPanel.setAttribute("open", "");
          }

          submenuPanel.focus();
        });

        submenuCloseButton.addEventListener("click", () => {
          menuPanel.removeAttribute("hidden");
          if (submenuPanel.close) {
            submenuPanel.close();
          } else {
            submenuPanel.removeAttribute("open");
          }

          showButton.focus();
        });
      });
    });

    mediaQueryList.addEventListener("change", (event) => {
      if (event.matches && menu.getAttribute("open") === "") {
        closeMenu();
      }
    });

    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && menu.getAttribute("open") === "") {
        closeMenu();
      }
    });

    const showPanel = (panel, showButton) => {
      if (searchPanel && searchPanel.getAttribute("open") === "") {
        searchPanel.removeAttribute("open");
      }
      if (panel.show) {
        panel.show();
      } else {
        panel.setAttribute("open", "");
      }

      setTimeout(() => {
        document.getElementById("shopify-section-header").style =
          "transform: none";
        backdrop.setAttribute("data-active", "");
      });

      showButton.setAttribute("data-active", "");
    };

    const closePanel = (panel, showButton) => {
      if (panel.close) {
        panel.close();
      } else {
        panel.removeAttribute("open");
      }

      document.body.classList.remove("overflow-hidden");
      backdrop.removeAttribute("data-active");
      showButton.removeAttribute("data-active");
    };

    panelShowButtons.forEach((showButton) => {
      const id = showButton.getAttribute("aria-controls");
      const panel = document.getElementById(id);
      const panelContent = panel.querySelector("[data-panel-content]");

      const updatePanelHeight = () => {
        if (panelContent) {
          panel.style = `--height: ${panelContent.scrollHeight / 16}rem`;
        }
      };

      updatePanelHeight();

      showButton.addEventListener("mouseover", () => {
        showPanel(panel, showButton, backdrop);

        setTimeout(() => {
          panel.focus();
        }, 500);
      });

      panel.addEventListener("focusout", () => {
        setTimeout(() => {
          if (!panel.contains(document.activeElement)) {
            closePanel(panel, showButton);
          }
        });
      });

      showButton.addEventListener("keydown", (event) => {
        if (event.key === " ") {
          showPanel(panel, showButton);

          setTimeout(() => {
            panel.focus();
          }, 500);
        }
      });

      document.addEventListener("click", () => {
        if (panel.getAttribute("open") === "") {
          closePanel(panel, showButton, backdrop);
        }
      });

      window.addEventListener("resize", updatePanelHeight, true);

      window.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && panel.getAttribute("open") === "") {
          closePanel(panel, showButton, backdrop);
        }
      });

      mediaQueryList.addEventListener("change", (event) => {
        if (!event.matches && panel.getAttribute("open") === "") {
          closePanel(panel, showButton, backdrop);
        }
      });
    });

    searchShowButtons.forEach((showButton) => {
      showButton.addEventListener("click", () => {
        const id = showButton.getAttribute("aria-controls");
        const search = document.getElementById(id);

        if (search.getAttribute("open") === "") {
          closePanel(search, showButton);
        } else {
          showPanel(search, showButton);

          setTimeout(() => {
            search.querySelector("input").focus();
          }, 500);
        }

        document.addEventListener("click", (event) => {
          if (
            !search.contains(event.target) &&
            !showButton.contains(event.target) &&
            search.getAttribute("open") === ""
          ) {
            closePanel(search, showButton);
          }
        });

        window.addEventListener("keydown", (event) => {
          if (event.key === "Escape" && search.getAttribute("open") === "") {
            closePanel(search, showButton);
          }
        });
      });
    });
  }
}

customElements.define("header-wrapper", HeaderWrapper);
